import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * CRM 관리자 인증 필수 라우트 래퍼.
 * - 관리자 로그인 상태가 아니면 /admin/login 으로 리다이렉트.
 * - 리다이렉트 시 원래 접근하려던 경로를 state.from 으로 넘겨서 로그인 후 복귀 가능.
 */
const AdminProtectedRoute = ({ children }) => {
  const { isAdminAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAdminAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return children;
};

export default AdminProtectedRoute;
